import { ProductDivisionListPage } from "@/features/product-division/pages/ProductDivisionListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-division/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_division.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDivisionListPage,
});
